import { MetadataUpdateKeyValue } from "@cinesys/experience-ui/components";

/**
 * Remembers the last schema + field values a user typed into a synthetic (not-yet-created)
 * item's metadata form, so the next time they open the same flow it's pre-filled. Used by both
 * the Import flow's schema form and the Create Placeholder page — each passes its own
 * `storageKey` so the two flows don't clobber each other's remembered values.
 */
interface StoredValues {
  schema: string;
  values: MetadataUpdateKeyValue[];
}

export const loadLastValues = (
  storageKey: string,
  schema: string
): MetadataUpdateKeyValue[] => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw) {
      const parsed = JSON.parse(raw) as StoredValues;
      if (parsed.schema === schema) {
        return parsed.values;
      }
    }
  } catch {}
  return [];
};

export const saveLastValues = (
  storageKey: string,
  schema: string,
  values: MetadataUpdateKeyValue[]
): void => {
  try {
    localStorage.setItem(storageKey, JSON.stringify({ schema, values }));
  } catch {}
};

export const loadLastSchema = (storageKey: string): string | undefined => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw) {
      return (JSON.parse(raw) as StoredValues).schema;
    }
  } catch {}
  return undefined;
};
